import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { RestService } from "../../../services/rest/rest.service";
import { CommonService } from "../../../services/common/common.service";
import { HelpIndex, Endpoint } from "../../../models/enums";
import { BaseModalComponent } from "../../../models/base-modal-component";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { AlignDirection, GenericColDef } from "../../../models/grid-context";
import { AuditLog } from "../../../models/audit-log";
import { GenericGridComponent } from "../../generic-grid/generic-grid.component";
import { DrRequestInfo } from "../../../models/dr-request-info";

@Component({
    standalone: false,
    selector: "res-audit-log-modal",
    templateUrl: "./audit-log-modal.component.html",
    styleUrls: ["./audit-log-modal.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class AuditLogModalComponent
    extends BaseModalComponent
    implements OnInit {
    @ViewChild(GenericGridComponent, { static: true })
    genericGrid: GenericGridComponent;

    modalTitle = "Audit Log";
    secondaryButtonLabel = "Close";
    maximizable: false;
    modalHelpIndex = HelpIndex.case_audit_log;
    modalAutomationId = "audit-log";
    modalClass = "audit-log-modal";
    gridName = "AuditLog";
    event: AuditLog;
    isBusy = false;
    isBusyMessage = "Loading...";

    requestInfo = new DrRequestInfo({
        endpoint: Endpoint.projectManager_listAuditLogEvents,
        responseName: "events",
    });

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private restService: RestService,
        private commonService: CommonService
    ) {
        super(modalService, modalRef);
    }

    columnDefs = new Array<GenericColDef>(
        {
            headerName: "Username",
            field: "user",
            automationId: this.modalAutomationId,
            lockVisible: true,
        },
        {
            headerName: "Date",
            field: "date",
            automationId: this.modalAutomationId,
            headerAlignDirection: AlignDirection.right,
            cellAlignDirection: AlignDirection.right,
        },
        {
            headerName: "Status",
            field: "eventType",
            automationId: this.modalAutomationId,
            lockVisible: true,
        },
        {
            headerName: "Operation",
            field: "operationType",
            automationId: this.modalAutomationId,
            lockVisible: true,
        },
        {
            headerName: "View Name",
            field: "collectionName",
            automationId: this.modalAutomationId,
            lockVisible: true,
        },
        {
            headerName: "Description",
            automationId: this.modalAutomationId,
            width: 500,
            lockVisible: true,
            valueGetter: function tokenNameGetter(params) {
                return params.data.description
                    .replace(/>/g, "&gt;")
                    .replace(/</g, "&lt;");
            },
        },
        {
            headerName: "Duration",
            field: "duration",
            automationId: this.modalAutomationId,
            headerAlignDirection: AlignDirection.right,
            cellAlignDirection: AlignDirection.right,
            lockVisible: true,
        },
        {
            headerName: "Results",
            field: "resultCount",
            automationId: this.modalAutomationId,
            headerAlignDirection: AlignDirection.right,
            cellAlignDirection: AlignDirection.right,
            lockVisible: true,
        },
        {
            headerName: "Software Version",
            field: "swVersion",
            automationId: this.modalAutomationId,
            lockVisible: true,
        },
        {
            headerName: "Workbasket Handle",
            field: "workbasketHandle",
            automationId: this.modalAutomationId,
            hide: true,
        },
        {
            headerName: "SRI Handle",
            field: "sriHandle",
            automationId: this.modalAutomationId,
            hide: true,
        }
    );

    ngOnInit() {
        this.requestInfo.data = {
            projectHandle: this.commonService.currentProject.handle,
        };
        this.genericGrid.loadData();
    }

    downloadCSV(): void {
        this.commonService.openInformationToastNotification('Processing of the Audit Log for download has started. Once finished, the Audit Log can be downloaded from the Work Basket.');
        this.restService.post(Endpoint.projectManager_createAuditLogManifest, {
            projectHandle: this.commonService.currentProject.handle,
        });
    }

    close() {
        this.closeModal(true);
    }
}
